import { gql } from "@apollo/client";

export const QUERY_PERMISSIONS = gql`
  query getPermissionsForRole($role: String!) {
    getPermissionsForRole(role: $role) {
      permissions
    }
  }
`;
